"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getCachedAssetResolver;
const ApiHelper_1 = require("@aurora/shared-client/helpers/ApiHelper");
const assets_1 = require("@aurora/shared-types/assets");
const log_1 = require("@aurora/shared-utils/log");
const log = (0, log_1.getLog)(module);
function getCachedAssetResolver(assetProvider, appType) {
    return (_, queryArguments, context) => __awaiter(this, void 0, void 0, function* () {
        const now = performance.now();
        const { client, tenant } = context;
        const { id: tenantId } = tenant;
        const { assetId, assetType, node, locale, lastModified = assets_1.LastModifiedKeys.DEFAULTS_ONLY } = queryArguments;
        log.trace('Resolving asset for id: %s and tenant %s', assetId, tenantId);
        let asset;
        if (typeof window === 'undefined') {
            asset = yield assetProvider(assetId, assetType, node, locale, client, tenant, lastModified);
        }
        else {
            asset = yield (0, ApiHelper_1.getCachedAssetFromApi)(assetType, [assetId, node, locale], appType, lastModified);
        }
        log.trace('Asset resolved for id: %s and tenant %s in %dms', assetId, tenantId, performance.now() - now);
        return asset;
    });
}
//# sourceMappingURL=cachedAssetResolverBase.js.map